import { render, staticRenderFns } from "./OtherOrgan.vue?vue&type=template&id=3d132173&scoped=true&"
import script from "./OtherOrgan.vue?vue&type=script&lang=js&"
export * from "./OtherOrgan.vue?vue&type=script&lang=js&"
import style0 from "./OtherOrgan.vue?vue&type=style&index=0&id=3d132173&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d132173",
  null
  
)

export default component.exports